import { Controller } from "@hotwired/stimulus"

const HIDE_DELAY_MS = 150
const VISIBLE_CLASS = "opacity-100 visible"

export default class extends Controller {
  static targets = ["trigger", "bubble"]
  static values = { bubbleId: String, placement: { type: String, default: "above" } }

  connect() {
    this.hideTimeout = null
    this._isTouch = window.matchMedia("(pointer: coarse)").matches
  }

  show() {
    if (this._isTouch) return
    this.cancelHide()
    if (!this.hasBubbleTarget) return
    this.bubbleTarget.classList.add(...VISIBLE_CLASS.split(" "))
    this.bubbleTarget.setAttribute("aria-hidden", "false")
    if (this.hasTriggerTarget && this.bubbleIdValue) {
      this.triggerTarget.setAttribute("aria-describedby", this.bubbleIdValue)
    }
  }

  hide() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
    if (!this.hasBubbleTarget) return
    this.bubbleTarget.classList.remove(...VISIBLE_CLASS.split(" "))
    this.bubbleTarget.setAttribute("aria-hidden", "true")
    if (this.hasTriggerTarget) {
      this.triggerTarget.removeAttribute("aria-describedby")
    }
  }

  scheduleHide() {
    if (this._isTouch) return
    this.hideTimeout = setTimeout(() => this.hide(), HIDE_DELAY_MS)
  }

  cancelHide() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
    }
  }

  toggle(event) {
    if (!this._isTouch) return
    event.preventDefault()
    if (!this.hasBubbleTarget) return
    const isVisible = this.bubbleTarget.classList.contains("opacity-100")
    if (isVisible) {
      this.hide()
    } else {
      this.showForTouch()
    }
  }

  showForTouch() {
    if (!this.hasBubbleTarget) return
    this.bubbleTarget.classList.add(...VISIBLE_CLASS.split(" "))
    this.bubbleTarget.setAttribute("aria-hidden", "false")
    if (this.hasTriggerTarget && this.bubbleIdValue) {
      this.triggerTarget.setAttribute("aria-describedby", this.bubbleIdValue)
    }
  }

  closeIfOutside(event) {
    if (!this.hasBubbleTarget || !this.hasTriggerTarget) return
    const isVisible = this.bubbleTarget.classList.contains("opacity-100")
    if (!isVisible) return
    const target = event.target
    if (this.element.contains(target)) return
    this.hide()
  }

  closeOnEscape(event) {
    if (event.key !== "Escape") return
    if (!this.hasBubbleTarget) return
    const isVisible = this.bubbleTarget.classList.contains("opacity-100")
    if (!isVisible) return
    event.preventDefault()
    this.hide()
    if (this.hasTriggerTarget && typeof this.triggerTarget.focus === "function") {
      this.triggerTarget.focus()
    }
  }
}
